export const styles = {
    wrapper: {
        py: [6, 8],
        gap: [6, 10],
        flexDirection: { base: "column", xl: "row" },
    },
    listColumn: {
        flexDirection: "column",
        justifyContent: "center",
        gap: [4, 5],
        flex: { base: "unset", xl: "0 0 38%" },
    },
    title: {
        fontSize: ["mobileHeading1", "desktopHeading1"],
        fontWeight: "bold",
    },
    list: {
        flexDirection: "column",
        gap: [3, 4],
    },
    listItemLink: {
        _hover: { textDecoration: "none" },
    },
    imageColumn: {
        position: "relative",
        w: "full",
        aspectRatio: ["4/3", "16/10"],
    },
    imageLayer: {
        position: "absolute",
        inset: 0,
        transition: "opacity 0.4s ease",
    },
};

export const listItemStyle = (isActive: boolean, colorText: string) => ({
    fontSize: ["mobileBodyB1", "desktopBodyB1"],
    fontWeight: "bold",
    color: isActive ? colorText : "gray.500",
    transition: "color 0.2s ease",
    cursor: "pointer",
});
